export default class Office {
  constructor(listItemElement) {
    this.settings = Object.assign({
      lat: 0,
      lng: 0,
      type: '',
      zoom: undefined,
    }, listItemElement.dataset);

    this.placemark = undefined;
    this.content = undefined;

    this.listItemElement = listItemElement;

    this.link = this.listItemElement.querySelector('[data-list-item-link]');

    this.block = this.listItemElement.querySelector('[data-list-item-block]');

    if (this.block) {
      this.content = this.block.children[0];
    }

    this.routeLink = this.listItemElement.querySelector('[data-list-item-route-link]');
    this.setRouteLinkHref();

    this.defineHeight();
  }

  getLat() {
    return parseFloat(this.settings.lat);
  }

  getLng() {
    return parseFloat(this.settings.lng);
  }

  setPlacemark(placemark) {
    this.placemark = placemark;
  }

  getPlacemark() {
    return this.placemark;
  }

  defineHeight() {
    if (this.content) {
      this.targetHeight = this.content.clientHeight;
    }
  }

  setRouteLinkHref() {
    if (this.getLat() && this.getLng() && this.routeLink) {
      this.routeLink.href = `https://yandex.ru/maps/?rtext=~${this.getLat()},${this.getLng()}&rtt=mt`;
    }
  }
}